import React, { useEffect } from "react";
import { Checkbox } from "../Checkbox";
export interface TermsAcceptanceProps {
  emailTerms?: string;
  businessOverviewTerms?: string;
  emailTermsLabel?: string;
  isBusinessOverview?: boolean;
  isLoading: boolean;
  isTermsChecked: boolean;
  isEmailTermsChecked: boolean;
  setIsTermsChecked: (value: boolean) => void;
  setIsEmailTermsChecked: (value: boolean) => void;
  disableEmailCheckbox?: boolean;
}

export const TermsAcceptance = ({
  emailTerms = `I agree to receive Ecologi email updates about my impact,
    important related news and other ways to help make a difference. You can
    unsubscribe later from your account settings at any time.`,
  businessOverviewTerms = `I agree to receive Ecologi email updates about
    important related news and other ways to help make a difference. You can
    unsubscribe later at any time.`,
  emailTermsLabel = "Ecologi Communications Opt-in",
  isLoading,
  isTermsChecked,
  isEmailTermsChecked,
  isBusinessOverview,
  setIsTermsChecked,
  setIsEmailTermsChecked,
  disableEmailCheckbox,
}: TermsAcceptanceProps) => {
  useEffect(() => {
    // if email checkbox is disabled user is going to receive Ecologi email updates by default
    if (disableEmailCheckbox) setIsEmailTermsChecked(true);
  }, [disableEmailCheckbox]);

  return (
    <>
      <Checkbox.WithMarginBottom
        isDisabled={isLoading}
        isSelected={isTermsChecked}
        label="Terms and Conditions"
        isMarginBottomSmall={!disableEmailCheckbox}
        onChange={setIsTermsChecked}
        $size={disableEmailCheckbox ? 32 : 0}
      >
        <>
          I agree to the{" "}
          <Checkbox.InlineLabelLink
            as="a"
            href="/pages/terms-and-conditions"
            rel="noopener noreferrer"
            target="_blank"
            title="View the Ecologi Terms and Conditions"
            use="inlineLink"
          >
            Terms and Conditions
          </Checkbox.InlineLabelLink>
          {" and "}
          <Checkbox.InlineLabelLink
            as="a"
            href="/pages/privacy-policy"
            rel="noopener noreferrer"
            target="_blank"
            title="View the Ecologi Privacy Policy"
            use="inlineLink"
          >
            Privacy Policy
          </Checkbox.InlineLabelLink>
        </>
      </Checkbox.WithMarginBottom>
      {!disableEmailCheckbox && (
        <Checkbox.WithMarginBottom
          isSelected={isEmailTermsChecked}
          label={emailTermsLabel}
          isDisabled={isLoading}
          onChange={setIsEmailTermsChecked}
        >
          {isBusinessOverview ? businessOverviewTerms : emailTerms}
        </Checkbox.WithMarginBottom>
      )}
    </>
  );
};
